import { z } from 'zod'

export const AppConfigSchema = z.object({
  requestTTL: z.string().regex(/^\d+$/).transform(Number),
  apiVersion: z.string().regex(/^\d+$/),
  developmentState: z.enum(['prod', 'stage', 'dev']),
  env: z.enum(['stage', 'development', 'prod', 'test']),
  imageServiceCdn: z.string().url('Invalid Image service Url'),
  apiUrl: z.string().url('Invalid API url'),
  appUrl: z.string().url('Invalid app url'),
  devVueAppUrl: z.string().url('Invalid app url').optional(),
  version: z.string(),
  rumApplicationId: z.string().min(3, 'Invalid Rum application Id'),
  rumClientToken: z.string().min(3, 'Invalid Rum client token'),
  userCentricsScriptId: z.string().min(3, 'Invalid onTrust scriptId'),
  funWithFlagsToken: z.string().min(3, 'Invalid funWithFlags token'),
  fingerprintJS: z
    .object({
      key: z.string().min(3, 'Invalid FingerprintJS key'),
      behaviorPath: z.string().min(3, 'Invalid FingerprintJS behavior path'),
      agentDownloadPath: z.string().min(3, 'Invalid FingerprintJS agent download path'),
      getResultPath: z.string().min(3, 'Invalid FingerprintJS get result path'),
    })
    .optional(),
  googleClientId: z.string().min(3, 'Invalid Google Client ID'),
  googleMapsKey: z.string().min(3, 'Invalid Google Maps Api Key'),
  mParticleId: z.string().min(3, 'Invalid mParticle ID'),
  facebookAppId: z.string().min(3, 'Invalid Facebook App ID'),
  brazeId: z.string().min(3, 'Invalid Braze ID'),
  kustomerApiKey: z.string().min(3, 'Invalid Kustomer API Key'),
  reCaptchaKey: z.string().min(3, 'Invalid Recaptcha API Key'),
  googleTagManagerId: z.string().min(3, 'Invalid google Tag Manager Id'),
  paymentHost: z.string(),
  appStoreUrl: z.string().min(3, 'Invalid app store url'),
  playMarketUrl: z.string().min(3, 'Invalid play market url'),
  applePayMerchantId: z.string(),
  googleMerchantId: z.string(),
  processOutKey: z.string(),
  helloSignApiKey: z.string(),
  airTableApiKey: z.string(),
  airTableBaseId: z.string(),
  airTableTableId: z.string(),
})

export type AppConfigDynamic = z.infer<typeof AppConfigSchema>

export interface AppConfigStatic {
  isBrowser: boolean
  isDevelopment: boolean
  name: string
  project: string
  appType: string
  platform: 'web' | 'github-actions'
}

export type AppConfig = AppConfigDynamic & AppConfigStatic
